module.exports = __webpack_public_path__ + "img/wecom-temp-7a5e699c763eca5bceda89b3116206e3.7a5e699c.png";